module.exports = __webpack_public_path__ + "img/ner.b7369ec7.svg";